import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, Award, Shield } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="/assets/images/logo-footer.png" 
                alt="Trademark Frontline" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner in trademark registration and intellectual property protection. Securing brands nationwide since 2010 with expert legal guidance.
            </p>
            <div className="space-y-3">
              <a href="mailto:info@trademarkfrontline.com" className="flex items-center gap-3 text-gray-400 hover:text-blue-400 transition-colors group">
                <div className="bg-gray-800 p-2 rounded-lg group-hover:bg-blue-900/30 transition-colors">
                  <Mail size={18} />
                </div>
                <span>info@trademarkfrontline.com</span>
              </a>
              <a href="tel:+18446270636" className="flex items-center gap-3 text-gray-400 hover:text-blue-400 transition-colors group">
                <div className="bg-gray-800 p-2 rounded-lg group-hover:bg-blue-900/30 transition-colors">
                  <Phone size={18} />
                </div>
                <span>+1 (844) 627-0636</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <div className="bg-gray-800 p-2 rounded-lg">
                  <MapPin size={18} />
                </div>
                <span>515 Flower St, Los Angeles, CA 90071, USA</span>
              </div>
            </div>
          </div>

          {/* Trademark Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-blue-400">Trademark Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/trademark-registration" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-search" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/services/clearance-search" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Clearance Search
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-monitoring" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Trademark Monitoring
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-renewal" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Trademark Renewal
                </Link>
              </li>
              <li>
                <Link to="/services/statements-of-use" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Statements of Use
                </Link>
              </li>
            </ul>
          </div>

          {/* Other Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-blue-400">Other Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services/copyright-registration" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/company-formation" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/services/llc-formation" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  LLC Formation
                </Link>
              </li>
              <li>
                <Link to="/services/patent-filing" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Patent Filing
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Amazon Brand Registry
                </Link>
              </li>
              <li>
                <Link to="/services/cease-and-desist" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Cease and Desist
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-blue-400">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  All Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white hover:pl-2 transition-all">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-gray-900/50">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-400 text-sm">
              © 2026 <span className="font-semibold text-blue-400">Trademark Frontline</span>. All rights reserved.
            </div>
            <div className="flex items-center gap-4 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-blue-400 transition-colors">
                Terms and Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};